type FingerprintAgent = {
  get: () => Promise<{ visitorId?: string }>;
};

type FingerprintLoader = {
  load: () => Promise<FingerprintAgent>;
};

const lazyFingerprintLoader: FingerprintLoader = {
  async load() {
    const { default: FingerprintJS } = await import('@fingerprintjs/fingerprintjs');

    return FingerprintJS.load();
  },
};

export type BrowserFingerprintPayload =
  | { fingerprint_blocked: true }
  | { fingerprint_visitor_id: string };

function testOverride(): BrowserFingerprintPayload | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    if (window.localStorage.getItem('trinidad_test_fingerprint_blocked') === 'true') {
      return { fingerprint_blocked: true };
    }

    const visitorId = window.localStorage.getItem('trinidad_test_fingerprint_visitor_id')?.trim();

    return visitorId ? { fingerprint_visitor_id: visitorId } : null;
  } catch {
    return null;
  }
}

export async function collectBrowserFingerprint(
  loader: FingerprintLoader = lazyFingerprintLoader,
): Promise<BrowserFingerprintPayload> {
  const override = testOverride();

  if (override) {
    return override;
  }

  try {
    const agent = await loader.load();
    const result = await agent.get();
    const visitorId = result.visitorId?.trim();

    return visitorId ? { fingerprint_visitor_id: visitorId } : { fingerprint_blocked: true };
  } catch {
    return { fingerprint_blocked: true };
  }
}
